import Sidebar from "../../components/ui/sidebar";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { Megaphone } from "lucide-react";

const ingresosData = [
  { unidad: "Naranjos", ingreso: 12000 },
  { unidad: "Manzanos", ingreso: 9800 },
  { unidad: "Cedros", ingreso: 7200 },
  { unidad: "Pinos", ingreso: 4500 },
];

const pagosData = [
  { name: "Al día", value: 75 },
  { name: "En mora", value: 25 },
];

const tendenciaData = [
  { mes: "Ene", pagos: 3000 },
  { mes: "Feb", pagos: 4200 },
  { mes: "Mar", pagos: 3900 },
  { mes: "Abr", pagos: 5100 },
  { mes: "May", pagos: 4800 },
];

const COLORS = ["#16a34a", "#ef4444"];

export default function Dashboard() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      {/* Sidebar */}
      <Sidebar />

      {/* Contenido principal */}
      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Bienvenido!</h2>

        {/* Tarjetas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <Card className="shadow-lg border-l-4 border-green-500">
            <CardHeader>
              <CardTitle>Ingresos del mes</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold text-green-600">$18,200</p>
              <p className="text-sm text-gray-500">+12% respecto al mes pasado</p>
            </CardContent>
          </Card>

          <Card className="shadow-lg border-l-4 border-red-500">
            <CardHeader>
              <CardTitle>Pagos pendientes</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold text-red-500">34</p>
              <p className="text-sm text-gray-500">Propietarios en mora</p>
            </CardContent>
          </Card>

          <Card className="shadow-lg border-l-4 border-blue-500">
            <CardHeader>
              <CardTitle>Recaudo efectivo</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold">75%</p>
              <p className="text-sm text-gray-500">Meta: 90%</p>
            </CardContent>
          </Card>
          <Card
            className="shadow-lg border-l-4 border-military-500 cursor-pointer hover:shadow-xl transition"
            onClick={() => navigate("/tablero")}
          >
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Megaphone className="h-5 w-5 text-military-600" />
                Tablero publicitario
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">
                Gestiona y revisa las publicaciones de la unidad.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Gráficos */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6">
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle>Ingresos por unidad</CardTitle>
            </CardHeader>
            <CardContent>
              <ResponsiveContainer width="100%" height={250}>
                <BarChart data={ingresosData}>
                  <XAxis dataKey="unidad" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="ingreso" fill="#16a34a" radius={[8, 8, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>

          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle>Estado de propietarios</CardTitle>
            </CardHeader>
            <CardContent>
              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={pagosData}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    label
                  >
                    {pagosData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </div>

        {/* Tendencia de pagos */}
        <Card className="shadow-lg mt-4 sm:mt-6">
          <CardHeader>
            <CardTitle>Tendencia mensual de pagos</CardTitle>
          </CardHeader>
          <CardContent>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={tendenciaData}>
                <XAxis dataKey="mes" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="pagos"
                  stroke="#2563eb"
                  strokeWidth={3}
                  dot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
